import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {shakeCss} from '../../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface InfoBubbleActionInstructionProps {
  iconName: IconName;
  text: ReactNode;
  isAnimated: boolean;
  onAnimationEnd?: () => void;
}

/*
 * Style.
 */

interface InstructionStyleProps {
  $isAnimated?: boolean;
}
const StyledInstructionDiv = styled.div<InstructionStyleProps>`
  width: 100%;
  background-color: ${(p) => p.theme.palette.pink.shade10};
  padding: 13px 16px;
  border-radius: 16px;
  font-size: ${fontSizes.medium};
  display: grid;
  grid-template-columns: 16px 1fr;
  grid-column-gap: 15px;
  margin-top: 24px;
  ${(p) => p.$isAnimated && shakeCss};
`;

const StyledIconWrapper = styled.div`
  padding-top: 3px;
`;

/*
 * Component.
 */

export const InfoBubbleActionInstruction: FC<InfoBubbleActionInstructionProps> = (props) => {
  const theme = useUserTheme();

  return (
    <StyledInstructionDiv $isAnimated={props.isAnimated} onAnimationEnd={props.onAnimationEnd}>
      <StyledIconWrapper>
        <Icon name={props.iconName} color={theme.palette.pink.shade40} size={16} />
      </StyledIconWrapper>
      <div>{props.text}</div>
    </StyledInstructionDiv>
  );
};
